import { connect } from 'react-redux'
import DcfReviewDrawer from '../components/DcfReviewDrawer'
import { actions } from '../modules/DataCorrectionV2'

const mapStateToProps = ({ dataCorrectionV2, loading, user }, ownProps) => {
  return {
    dcfDetail: dataCorrectionV2?.dcfDetail || ownProps.dcfDetail,
    dcfLookups: dataCorrectionV2?.dcfLookups,
    studyID: ownProps.studyID,
    currentUser: user || null,
    loading: !!loading?.general,
  }
}

const mapDispatchToProps = {
  updateDcfStatus: actions.updateDcfStatus,
  updateDcfContent: actions.updateDcfContent,
  upsertDcfSignatures: actions.upsertDcfSignatures,
  deleteDcfSignature: actions.deleteDcfSignature,
  applyDcf: actions.applyDcf,
  downloadDcf: actions.downloadDcf,
  downloadDcfCsv: actions.downloadDcfCsv,
  fetchDcfPdfBytes: actions.fetchDcfPdfBytes,
  fetchReauthPubkey: actions.fetchReauthPubkey,
  postSigningReauth: actions.postSigningReauth,
  uploadSignedDcfPdf: actions.uploadSignedDcfPdf,
  fetchDcfList: actions.fetchDcfList,
  fetchDcfDetail: actions.fetchDcfDetail,
  fetchInstrumentSurvey: actions.fetchInstrumentSurvey,
  closeDrawer: actions.closeDrawer,
}

export default connect(mapStateToProps, mapDispatchToProps)(DcfReviewDrawer)
